import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__ from "../../utils/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__CdnIcon_variants_js_17cbca35__ from "./CdnIcon.variants.js";
function CdnIcon({ className, iconName, ...props }) {
    const classes = (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__.cn)(className, (0, __WEBPACK_EXTERNAL_MODULE__CdnIcon_variants_js_17cbca35__.cdnIconVariants)(props));
    return iconName ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
        className: classes,
        children: iconName
    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
        "data-testid": "empty-icon",
        className: classes
    });
}
export { CdnIcon };
